import { colors } from "@/styles/colors"
import { makeStyles } from "@material-ui/core"

const useStyles = makeStyles(() => ({
	link: {
		"& svg": {
			color: colors.purple[800]
		},
		textDecoration: "underline",
		color: colors.purple[800]

	},
	icon: {
		display: "flex",
		justifyContent: "center",
		alignItems: "center"
	},
	text: {
		color: colors.purple[800]
	}
}))

export default useStyles
